import React from "react";
import { get } from "lodash";
import formatCurrency from "@tvg/formatter/currency";
import { BetSelection } from "@tvg/ts-types/Bet";
import { FavoriteTag as YellowTag } from "@tvg/ipp/src/components/SimpleInlineInfo/styled-components";
import {
  DetailedViewInfoContainer,
  RaceOdds,
  Tag,
  WillPays
} from "../styled-components";

export interface ListItemDetailsProps {
  showDetails: boolean;
  isWinnerBI: boolean;
  isUnknownWinnerStatus: boolean;
  runner: BetSelection;
  isCanceled: boolean;
  isBetRefund: boolean;
  isLastRowOfRunners: boolean;
  showTag: boolean;
  isRaceOver: boolean;
}

const ListItemDetails = ({
  showDetails,
  isWinnerBI,
  isUnknownWinnerStatus,
  runner,
  isBetRefund,
  isCanceled,
  isLastRowOfRunners,
  showTag,
  isRaceOver
}: ListItemDetailsProps) => (
  <DetailedViewInfoContainer>
    {showDetails && (
      <>
        {isWinnerBI && (
          <RaceOdds>
            {runner.alternate?.currentOdds ? (
              // Show alternate odds if alternate is winner and has odds
              <>
                {get(runner.alternate, "currentOdds.numerator")}
                {get(runner.alternate, "currentOdds.denominator")
                  ? `/${get(runner.alternate, "currentOdds.denominator")}`
                  : ""}
              </>
            ) : (
              // Show runner odds if runner is winner and has odds
              get(runner, "currentOdds") && (
                <>
                  {get(runner, "currentOdds.numerator")}
                  {get(runner, "currentOdds.denominator")
                    ? `/${get(runner, "currentOdds.denominator")}`
                    : ""}
                </>
              )
            )}
          </RaceOdds>
        )}
        {get(runner, "isFavorite", false) && isRaceOver && (
          <Tag>
            <YellowTag as="span">FAV</YellowTag>
          </Tag>
        )}
        {!isCanceled &&
          !isBetRefund &&
          !isUnknownWinnerStatus &&
          get(runner, "willPayAmount", 0) > 0 &&
          isLastRowOfRunners && (
            <WillPays>
              {formatCurrency(get(runner, "willPayAmount", 0), "USD")}
            </WillPays>
          )}
      </>
    )}
    {showTag && (
      <Tag>
        <YellowTag as="span">REFUND</YellowTag>
      </Tag>
    )}
  </DetailedViewInfoContainer>
);

export default ListItemDetails;
